import React, { memo } from 'react';
import classNames from 'classnames';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { ChevronRightBold } from '@johnlewispartnership/wtr-ingredients/foundations/icons';

import styles from 'components/Product/Promotion/Description/PromotionDescription.scss';

type PricePromotionDescriptionProps = {
  backgroundColor?: string;
  description: string;
  isLink?: boolean;
  isWMXOffer?: boolean;
  myWaitrosePromotion?: boolean;
  noMargin?: boolean;
  price: string;
  underlineText?: boolean;
  withChevron?: boolean;
};

const PricePromotionDescription = ({
  backgroundColor = undefined,
  description,
  isLink = false,
  isWMXOffer = false,
  myWaitrosePromotion = false,
  noMargin = false,
  price,
  underlineText = false,
  withChevron = false,
}: PricePromotionDescriptionProps) => {
  return (
    <Typography
      className={classNames(styles.offerDescription, {
        [styles.withBackground]: !!backgroundColor,
        [styles.green]: myWaitrosePromotion || backgroundColor === 'green',
        [styles.underline]: underlineText,
      })}
      data-testid="offer-description"
      noMargins={noMargin}
      styleAs="paragraphHeading"
      textStyle="heading-l"
    >
      <span>
        {`${description}${isWMXOffer || myWaitrosePromotion ? '' : '.'}`}
        {!isWMXOffer && !myWaitrosePromotion && (
          <em data-testid="was-price-description">{` Was ${price}`}</em>
        )}
      </span>
      {backgroundColor && isLink && withChevron && (
        <ChevronRightBold size="xsmall" className={styles.chevronIcon} />
      )}
    </Typography>
  );
};

PricePromotionDescription.displayName = 'PricePromotionDescription';

export default memo(PricePromotionDescription);
